import { RouteParamsGeneric, useRoute, useRouter } from 'vue-router';
import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
import { watchEffect, ref } from 'vue';
import ContextState from '@/VueCore/stores/Models/contextState';

export default function usePageLoading(loadingCallback: (routeParams: RouteParamsGeneric) => Promise<void>,
  errorCallback?: (error: unknown) => void, options?: { reactiveReloading?: boolean, doNotShowSpinner?: boolean, doNotDisablePage?: boolean }) {
  const route = useRoute();
  const router = useRouter();
  const contextData = useContextDataStore() as ContextState;
  const loading = ref<boolean>(true);

  async function load() {
    loading.value = true;

    if (!options?.doNotDisablePage) {
      contextData.disableElement = true;
    }

    if (!options?.doNotShowSpinner) {
      contextData.showPageLoadingSpinner = true;
    }

    try {
      await loadingCallback(route.params);
    } catch (error) {
      if (errorCallback) {
        errorCallback(error);
      }
      await router.push({
        name: 'NotAvailable',
        // preserve current path and remove the first char to avoid the target URL starting with `//`
        params: { pathMatch: route.path.substring(1).split('/') },
        // preserve existing query and hash if any
        query: route.query,
        hash: route.hash
      });
    }

    if (!options?.doNotDisablePage) {
      contextData.disableElement = false;
    }

    if (!options?.doNotShowSpinner) {
      contextData.showPageLoadingSpinner = false;
    }

    loading.value = false;
  }

  if (options?.reactiveReloading) {
    watchEffect(async () => {
      await load();
    });
  } else {
    load();
  }

  return {
    loadingPage: loading,
    loadPage: load
  };
}